// Tracks, per restaurant, whether this browser has already clicked through to
// Google reviews — so we stop asking once they've done it. This is an intent
// signal (we can't verify an actual Google review was posted), stored locally
// since it's not meaningful content worth a DB row.
const clickedKey = (restaurantId: string) => `google_review_clicked_${restaurantId}`;
const popupKey   = (restaurantId: string) => `google_review_popup_shown_${restaurantId}`;

export function hasClickedGoogleReview(restaurantId?: string | null): boolean {
  if (!restaurantId) return false;
  try { return localStorage.getItem(clickedKey(restaurantId)) === '1'; } catch { return false; }
}

export function markGoogleReviewClicked(restaurantId: string) {
  try { localStorage.setItem(clickedKey(restaurantId), '1'); } catch {}
}

// Popup should appear once per browser session (tab), not on every navigation.
export function hasSeenGooglePopupThisSession(restaurantId?: string | null): boolean {
  if (!restaurantId) return true;
  try { return sessionStorage.getItem(popupKey(restaurantId)) === '1'; } catch { return true; }
}

export function markGooglePopupSeen(restaurantId: string) {
  try { sessionStorage.setItem(popupKey(restaurantId), '1'); } catch {}
}

// A URL saved without "http(s)://" (e.g. "google.com") is treated by window.open
// as a path relative to the current page, not an external link — normalize it.
export function normalizeExternalUrl(url: string): string {
  const trimmed = url.trim();
  if (!trimmed) return trimmed;
  return /^https?:\/\//i.test(trimmed) ? trimmed : `https://${trimmed}`;
}
